/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import classNames from "classnames";

/* Components */
import { ReactComponent as Close } from "../../resources/images/icon-notification-close.svg";
import UCButton from "components/buttons";

/* Styles */
import styles from "./styles.js";

const GeneralBanner = (props) => {
  const {
    title,
    message,
    dismissBannerAction,
    closable = false,
    icon,
    buttonText,
    actionableButton,
    buttonAction,
    classes: customClasses = {},
  } = props;
  
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classNames(classes.banner, customClasses.banner)}>
      <div className={classNames(classes.bannerContent, customClasses.bannerContent)}>
        {icon && (
          <div className={classNames(classes.icon, customClasses.icon)}>
            {icon}
          </div>
        )}
        <div className={classNames(classes.bannerTextContainer, customClasses.bannerTextContainer)}>
          <div className={classNames(classes.bannerTitle, customClasses.bannerTitle)}>
            {title}
          </div>
          <div className={classNames(classes.bannerDescription, customClasses.bannerDescription)}>
            {message}
          </div>
        </div>
      </div>
      {actionableButton && (
        <UCButton
          type="default"
          className={classes.pendingInvitesBtn}
          text={buttonText}
          onClick={buttonAction}
        />
      )}
      {closable && (
        <Close
          className={classNames(classes.closeIcon, customClasses.closeIcon, !actionableButton && classes.noButtonPresent)}
          onClick={dismissBannerAction}
        />
      )}
    </div>
  );
};

export default GeneralBanner;